export default __webpack_public_path__ + "static/media/CherryPicker.6f10e684.png";